import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageShell } from '../../components/layout/PageShell'

// Public page — used as the "User data deletion" URL for Facebook/Google and as the
// account-deletion instructions required by the App Store / Google Play.
export function DataDeletionPage() {
  const { t } = useTranslation()
  const { locale: routeLocale = 'it' } = useParams()
  return (
    <PageShell>
      <div className="mb-6">
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-ink-900 sm:text-3xl">
          {t('legal.deletionTitle')}
        </h1>
        <p className="mt-1.5 text-sm text-ink-500">
          {t('legal.deletionSubtitle')}
        </p>
      </div>

      <div className="space-y-6 rounded-2xl bg-white p-5 text-sm leading-relaxed text-ink-600 shadow-card ring-1 ring-ink-100 sm:p-7">
        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.deletionStep1Title')}</h2>
          <p className="mt-1.5">
            {t('legal.deletionStep1Body')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.deletionStep2Title')}</h2>
          <p className="mt-1.5">
            {t('legal.deletionStep2BodyPre')}{' '}
            <a href="mailto:privacy@garagesanmarco.it" className="font-medium text-brand-600 underline">privacy@garagesanmarco.it</a>{' '}
            {t('legal.deletionStep2BodyPost')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.deletionRemovedTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.deletionRemovedBody')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.deletionKeptTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.deletionKeptBodyPre')}{' '}
            <strong>{t('legal.deletionKeptBodyAnon')}</strong> {t('legal.deletionKeptBodyPost')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.deletionSocialTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.deletionSocialBody')}
          </p>
        </section>

        <p className="text-ink-400">
          {t('legal.deletionQuestionsPre')}{' '}
          <a href="mailto:privacy@garagesanmarco.it" className="text-brand-600 underline">privacy@garagesanmarco.it</a>.
        </p>
      </div>

      <Link
        to={`/${routeLocale}`}
        className="mt-7 inline-flex h-11 items-center gap-2 rounded-xl border border-ink-200 px-5 text-sm font-semibold text-ink-700 hover:bg-ink-50"
      >
        <ArrowLeft className="h-4 w-4" /> {t('common.backHome')}
      </Link>
    </PageShell>
  )
}
